<template>
  <div>
    {{ healthCheckResponse }}
  </div>
</template>

<script>
export default {
  name: 'HealthCheck',
  data (router) {
    return {
      healthCheckResponse: null
    }
  },
  mounted () {
    this.$store.dispatch('authentication/healthCheckOpti', {})
      .then((res) => {
        this.healthCheckResponse = res
      }).catch((err) => {
        console.log('err', err)
      })
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/HealthCheckOpti.vue